import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form as ImportForm } from 'semantic-ui-react';
import excludeKeys from '../../../../../utils/excludeKeys';

class FormField extends Component {
  render() {
    return (
      <ImportForm.Field {...excludeKeys(this.props)}>
        { this.props.children }
      </ImportForm.Field>
    );
  }
}

export default FormField;

FormField.propTypes = {
  children: PropTypes.node,
};
